import { customerSubscriptionPaused } from 'src/data/customer';
// @ts-expect-error - no TypeScript definitions yet
import { useCurrentCustomer } from 'src/store/customer';

export const useViewState = () => {
  const customer = useCurrentCustomer();

  return {
    customerId: customer?.id,
    isPaused: customerSubscriptionPaused(customer),
    pauseEndAt: customer?.billingConfiguration?.subscriptionConfig?.pauseEndAt,
  };
};
